import Accordion from "components/core/basic/Accordion";
import { Button } from "components/core/basic/Button";
import { useFetch } from "hooks/api";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import { useQueryClient } from "@tanstack/react-query";
import { useAppSelector } from "redux/hooks";

const Entity = ({ entity, entityId }) => {
  const marketplace = useAppSelector((state) => state.marketPlace.marketPlace);
  const queryClient = useQueryClient();
  const queryKey = ["amazon", entity, entityId, marketplace];
  const { data, isLoading, dataUpdatedAt } = useFetch(
    queryKey,
    `/api/amazon/${entity}/${entityId}/`,
    {
      marketplace,
    },
    {
      select: (data) => data.data,
      retry: 3,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  if (isLoading) {
    return <div>Loading...</div>;
  }
  return (
    <Accordion title={`${entity} ${entityId}`}>
      <Row>
        <Col xs={12} className="d-flex justify-content-end">
          <div>
            <div>
              <Button
                onPress={() => {
                  queryClient.invalidateQueries({
                    queryKey: queryKey,
                  });
                }}
              >
                Refresh
              </Button>
            </div>
            <div>
              <small className="ms-2">Last updated: {moment(dataUpdatedAt).toISOString()}</small>
            </div>
          </div>
        </Col>
        <Col xs={12}>
          <pre>{JSON.stringify(data, null, 2)}</pre>
        </Col>
      </Row>
    </Accordion>
  );
};

const AmazonDebug = ({ entities }) => {
  return entities.map((entity) => <Entity key={entity.entityId} {...entity} />);
};

export default AmazonDebug;
